// @ts-check
import { ref, computed } from 'vue'
import { dependedCharConvert } from '@/utils/DependedChar'
import { isValidFormat } from '@/utils/Email'
import { password } from '@/studentsite/common/usePassword'
import { countVisibleLength } from '@/utils/countVisibleLength'

/**
 * @import { Ref } from 'vue'
 * @import { Props, Emits } from './emitTypes'
 */

/**
 * @param {Props} props
 * @param {Emits} emits
 * @returns
 */
export const setup = (props, emits) => {
  const formParams = ref({
    first_name: props.formParams.first_name,
    last_name: props.formParams.last_name,
    gender: props.formParams.gender,
    tel: props.formParams.tel,
    login_id: props.formParams.login_id,
    login_password: props.formParams.login_password,
  })
  // watch(userFirstName, newVal => { formParams.first_name = newVal })

  /** */
  const submitable = computed(() => {
    return (
      formParams.value.first_name &&
      formParams.value.last_name &&
      formParams.value.gender &&
      isValidTel.value &&
      isValidLoginId.value &&
      isValidLoginPw.value &&
      isValidLastName.value &&
      isValidFirstName.value
    )
  })
  /** @type { Ref<boolean> } */
  const isValidLastName = ref(true)
  /** @type { Ref<boolean> } */
  const isValidFirstName = ref(true)
  /** @type { Ref<boolean> } */
  const isValidTel = ref(true)
  /** @type { Ref<boolean> } */
  const isValidLoginId = ref(true)
  /** @type { Ref<boolean> } */
  const isValidLoginPw = ref(false)
  /** @type { Ref<string[]> } */
  const listLastNameValidation = ref([])
  /** @type { Ref<string[]> } */
  const listFirstNameValidation = ref([])
  /** @type { Ref<string[]> } */
  const listTelValidation = ref([])
  /** @type { Ref<string[]> } */
  const listIdValidation = ref([])
  /** @type { Ref<boolean[]> } */
  const listPwValidation = ref([])

  /** */
  const checkLastName = () => {
    const val = formParams.value.last_name ?? ''
    const length = countVisibleLength(val)
    if (length > 30) {
      listLastNameValidation.value = ['姓は30文字以内で入力してください。']
      isValidLastName.value = false
    } else {
      isValidLastName.value = true
      listLastNameValidation.value = []
    }
  }
  checkLastName()
  /** */
  const checkFirstName = () => {
    const val = formParams.value.first_name ?? ''
    const length = countVisibleLength(val)
    if (length > 30) {
      listFirstNameValidation.value = ['名は30文字以内で入力してください。']
      isValidFirstName.value = false
    } else {
      isValidFirstName.value = true
      listFirstNameValidation.value = []
    }
  }
  checkFirstName()
  /** */
  const checkTel = () => {
    const val = formParams.value.tel ?? ''
    if (val.length == 0) {
      isValidTel.value = false
      return
    }
    if (!val.match(/^\d{11}$/g)) {
      isValidTel.value = false
      listTelValidation.value = ['携帯番号は正しい形式で入力してください。']
    } else {
      isValidTel.value = true
      listTelValidation.value = []
    }
  }
  checkTel()
  /** */
  const checkLoginId = () => {
    const val = formParams.value.login_id ?? ''
    const length = countVisibleLength(dependedCharConvert(val.replace(/\r?\n/g, '')))
    if (length == 0) {
      isValidLoginId.value = false
    } else if (length > 150) {
      listIdValidation.value = ['メールアドレスは150文字以内で入力してください。']
      isValidLoginId.value = false
    } else if (!isValidFormat(val)) {
      listIdValidation.value = ['メールアドレスは正しい形式で入力してください。']
      isValidLoginId.value = false
    } else {
      listIdValidation.value = []
      isValidLoginId.value = true
    }
  }
  checkLoginId()
  /** */
  const checkLoginPw = () => {
    const val = formParams.value.login_password ?? ''
    listPwValidation.value = []

    if (val.length == 0) {
      isValidLoginPw.value = false
      return
    }

    listPwValidation.value.push(password()._isLength(val))
    listPwValidation.value.push(password()._isAllowedCombination(val))
    listPwValidation.value.push(password()._isDifferentChar(val))
    listPwValidation.value.push(password()._isAllowedChar(val))
    listPwValidation.value.push(password()._isNotConsecutive(val))

    isValidLoginPw.value = listPwValidation.value.filter(_ => !_).length === 0
  }
  checkLoginPw()

  const next = () => {
    emits('setParam', formParams.value)
  }

  return {
    formParams,
    listTelValidation,
    listIdValidation,
    listPwValidation,
    listFirstNameValidation,
    listLastNameValidation,
    submitable,
    next,
    checkTel,
    checkLoginId,
    checkLoginPw,
    checkLastName,
    checkFirstName,
  }
}
